import { lazyLoad } from 'utils/loadable';
import LoadingSpinner from 'app/components/Loading/LoadingSpinner';

export const BulkPolicyTransfer = lazyLoad(
    () => import('./index'),
    module => module.BulkPolicyTransfer,
    { fallback: <LoadingSpinner /> },
);
